module.exports = __webpack_public_path__ + "img/COPY.5d908cfd.svg";